/**
 * @constant route_acl_map 
 * key => route path
 * value => acl permission ID 
 */
export const route_acl_map = {
    "/company": "company_details",
    "/emergency-sessions": "show_emergency_sessions",
    "/emergency-list": "show_emergency_list",
    "/users": "users",
    "/announcements": "announcements",
    "/sites": "sites_devices",

    /**** Start :: Reporting ****/
    "/reporting/history": "show_history_list",
    "/reporting/users-not-on-site": "show_users_not_on_site_list",
    "/reporting/visit_summary": "show_visit_summary_list",
    "/reporting/timesheet": "show_time_sheet_list",
    "/track-trace": "show_track_trace_list",
    "/export-list": "show_export_list",
    "/reporting/kiosk-logs": "show_kiosk_logs_list",
    "/reporting/printer": "show_printer_list",
    /**** End :: Reporting ****/

    /**** Start :: User Settings ****/
    "/user-types": "show_user_types_list",
    "/add-user-type": "add_new_user_type",
    "/privacy-manager": "show_privacy_manager_list",
    "/users-settings": "user_settings",
    "/add-attendance-mode": "add_attendance_mode",
    "/attendance-modes": "show_attendance_modes",
    "/custom-fields": "show_custom_fields",
    "/add-custom-field": "add_custom_field_to_new_section",
    "/add-reason": "add_reason",

    /**** End :: User Settings ****/

    /**** Start :: Journey builder ****/
    "/journeys": "show_journey_list",
    "/add-journey": "create_journey",
    "/update/journey/:id": "edit_journey",
    "/add/journey/flow/:id": "add_journey_flow",
    "/add-flow": "add_journey_flow",
    "/update/journey/flow/:id": "edit_journey_flow",
    /**** End :: Journey builder ****/

    /**** Start :: Compliance ****/
    "/compliances": "show_compliance_list",
    "/compliance-new": "create_compliance",
    "/compliance/update/:id": "edit_compliance",
    /**** End :: Compliance ****/

    "/integration": "integration",

    // attendance mode 

    /**** Start :: Announcement ****/
    "/add-announcement": "add-announcement"

}